import styled from "styled-components";
import { mobile } from "../../../../../../ui/_themes/constants";
import * as helpers from "../../../../../../ui/_themes/helpers";

export const Wrapper = styled.div`
  pointer-events: all;
  color: ${helpers.getColor("headerHomeIcon", "header.homeIcon")};

  &[disabled] {
    color: ${helpers.getDisabledColor("headerHomeIcon", "header.homeIcon")};
  }

  @media (orientation: landscape) {
    height: ${mobile.landscape.sidePanel.icon.height};
    width: ${mobile.landscape.sidePanel.icon.width};
  }

  @media (orientation: portrait) {
    height: ${mobile.portrait.topPanel.header.icon.height};
    width: ${mobile.portrait.topPanel.header.icon.width};
  }
`;
